import React from 'react'
import Layout from '../elements/Layout'

const Accounts = () => {
  return (
    <Layout text="Accounts">Accounts</Layout>
  )
}

export default Accounts